const BaggageHoldColor = ({ color = '#bcbcbc' }) => {
  return (
    <svg
      width={24}
      height={49}
      viewBox="0 0 24 49"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.216553 46.0737C0.209897 46.3776 0.26484 46.6796 0.37807 46.9617C0.491301 47.2438 0.660475 47.5 0.875393 47.7149C1.09031 47.9298 1.34652 48.099 1.62858 48.2122C1.91064 48.3254 2.21271 48.3804 2.51658 48.3737H20.9493C21.2535 48.3804 21.556 48.3254 21.8385 48.2123C22.121 48.0992 22.3777 47.9301 22.5932 47.7153C22.8088 47.5005 22.9788 47.2444 23.0929 46.9623C23.207 46.6802 23.263 46.378 23.2575 46.0737V20.7328C23.2641 20.4278 23.209 20.1247 23.0953 19.8417C22.9817 19.5586 22.8119 19.3015 22.5962 19.0858C22.3806 18.8702 22.1235 18.7004 21.8404 18.5868C21.5574 18.4731 21.2542 18.418 20.9493 18.4246H2.51658C2.21201 18.4179 1.90925 18.4731 1.62664 18.5868C1.34402 18.7006 1.08743 18.8705 0.872395 19.0863C0.657361 19.3021 0.488362 19.5592 0.375631 19.8423C0.262899 20.1253 0.208781 20.4282 0.216553 20.7328V46.0737Z"
        fill={color}
      />
      <path
        d="M12.4561 26.0643C12.4561 25.6648 12.1341 25.3409 11.7368 25.3409C11.3396 25.3409 11.0176 25.6648 11.0176 26.0643V43.0503C11.0176 43.4498 11.3396 43.7737 11.7368 43.7737C12.1341 43.7737 12.4561 43.4498 12.4561 43.0503V26.0643Z"
        fill="white"
      />
      <path
        d="M8.27838 4.31561H6.83984V18.4246H8.27838V4.31561Z"
        fill={color}
      />
      <path
        d="M16.6338 4.31561H15.1953V18.4246H16.6338V4.31561Z"
        fill={color}
      />
      <path
        d="M6.83984 4.60818H8.29463V3.73856C8.28801 3.43539 8.34271 3.13401 8.45544 2.8525C8.56817 2.57099 8.73662 2.31516 8.95066 2.10036C9.1647 1.88555 9.41994 1.71621 9.70105 1.60248C9.98216 1.48875 10.2833 1.43299 10.5865 1.43853H12.8866C13.1904 1.43188 13.4925 1.48682 13.7746 1.60005C14.0566 1.71328 14.3128 1.88245 14.5277 2.09737C14.7427 2.31229 14.9118 2.5685 15.0251 2.85056C15.1383 3.13262 15.1932 3.43469 15.1866 3.73856V4.60818H16.6332V3.73856C16.6332 3.73856 16.6332 0 12.8866 0H10.5865C10.5865 0 6.83984 0 6.83984 3.73856V4.60818Z"
        fill={color}
      />
    </svg>
  );
};

export default BaggageHoldColor;
